import React from 'react';

// Updated type to match Backend expectations
type ColumnKeys =
  | 'name'
  | 'email'
  | 'contact_type'
  | 'created_at'
  | 'updated_at';

interface IContactColumnsProps {
  sortData: (key: string) => void;
  sortConfig: { key: string; direction: string };
}

const ContactColumns: React.FC<IContactColumnsProps> = ({
  sortData,
  sortConfig,
}) => {
  const getSortIcon = (key: ColumnKeys) => {
    if (sortConfig.key !== key) {
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
        >
          <path
            d='M8 4V12M8 4L4 8M8 4L12 8'
            stroke='var(--text-classify)'
            strokeOpacity='0.5'
            strokeWidth='1.33'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );
    }
    if (sortConfig.direction === 'asc') {
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
        >
          <path
            d='M8 12.6666V3.33331M8 3.33331L3.33333 7.99998M8 3.33331L12.6667 7.99998'
            stroke='var(--text-classify)'
            strokeWidth='1.33'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );
    }
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
      >
        <path
          d='M8 3.33331V12.6666M8 12.6666L3.33333 7.99998M8 12.6666L12.6667 7.99998'
          stroke='var(--text-classify)'
          strokeWidth='1.33'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    );
  };

  return (
    <div className='screening-results-columns'>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div
            className='screening-table-column-text'
            onClick={() => sortData('name')}
          >
            Name {getSortIcon('name')}
          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div
          className='screening-table-title-column-inner'
          onClick={() => sortData('email')}
        >
          <div className='screening-table-column-text'>
            Email {getSortIcon('email')}
          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div
          className='screening-table-title-column-inner'
          onClick={() => sortData('contact_type')}
        >
          <div className='screening-table-column-text'>
            Contact Type {getSortIcon('contact_type')}
          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div
          className='screening-table-title-column-inner'
          onClick={() => sortData('created_at')}
        >
          <div className='screening-table-column-text'>
            Created {getSortIcon('created_at')}
          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div
          className='screening-table-title-column-inner'
          onClick={() => sortData('updated_at')}
        >
          <div className='screening-table-column-text'>
            Updated {getSortIcon('updated_at')}
          </div>
        </div>
      </div>
      <div
        className='screening-table-placeholder-column'
        style={{
          borderTopRightRadius: 'var(--radius-xl, 12px)',
          justifyContent: 'center',
          width: '100px',
        }}
      ></div>
    </div>
  );
};

export default ContactColumns;
